import { Injectable } from "@angular/core";
import { WebTrackingService, hash } from "./web-tracking.service";

@Injectable({
  providedIn: "root"
})
export class WebTrackingInitService {
  private isInitialized = false;

  constructor(private webTrackingService: WebTrackingService) {}

  /**
   * Initialize tracking with user information
   * This should be called after successful login
   */
  public initialize(username: string, right: string): void {
    console.log("👓");
    if (this.isInitialized) return;
    try {
      const encryptedUserId = hash(username);
      this.webTrackingService.initializeTracking(encryptedUserId, right);
      this.isInitialized = true;
    } catch (error) {
      console.error("No session track:", error);
    }
  }

  /**
   * Stop tracking (call on logout)
   */
  public stop(): void {
    if (!this.isInitialized) return;
    this.webTrackingService.stopTracking();
    this.isInitialized = false;
  }

  /**
   * Check if tracking is initialized
   */
  public isTrackingInitialized(): boolean {
    return this.isInitialized;
  }
}
